import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { GranolaConnectSchema, GranolaDisconnectSchema, GranolaStatusSchema } from '../schemas/granola';

const headers = {
	'Key-Inflection': 'camel',
};

const granolaKeys = {
	all: ['granola'] as const,
	status: () => [...granolaKeys.all, 'status'] as const,
};

const granolaPaths = {
	status: () => '/granola/api_key/status',
	// MCP OAuth — kept for reference
	// authorize: () => '/granola_mcp/authorize',
	apiKey: () => '/granola/api_key',
	// MCP — kept for reference
	// meetings: () => '/granola_mcp/meetings',
};

export const useGranolaStatus = (enabled = true) => {
	const http = useHttpClient();
	return useQuery({
		queryKey: granolaKeys.status(),
		queryFn: async () => {
			const res = await http.get(granolaPaths.status(), { headers });
			return GranolaStatusSchema.parse(res.data);
		},
		enabled,
	});
};

// MCP OAuth — kept for reference
// export const useGranolaAuthorize = () => {
// 	const http = useHttpClient();
// 	return useMutation({
// 		mutationFn: async (returnPath?: string) => {
// 			const res = await http.get(granolaPaths.authorize(), {
// 				headers,
// 				params: returnPath ? { return_path: returnPath } : undefined,
// 			});
// 			return GranolaAuthorizeSchema.parse(res.data);
// 		},
// 	});
// };

// MCP — kept for reference
// export const useGranolaMeetings = () => {
// 	const http = useHttpClient();
// 	return useMutation({
// 		mutationFn: async () => {
// 			const res = await http.get(granolaPaths.meetings(), { headers });
// 			return res.data as { meetings: unknown[] };
// 		},
// 	});
// };

export const useGranolaConnect = () => {
	const http = useHttpClient();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (apiKey: string) => {
			const res = await http.post(granolaPaths.apiKey(), { api_key: apiKey }, { headers });
			return GranolaConnectSchema.parse(res.data);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: granolaKeys.all });
		},
	});
};

export const useGranolaDisconnect = () => {
	const http = useHttpClient();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async () => {
			const res = await http.delete(granolaPaths.apiKey(), { headers });
			return GranolaDisconnectSchema.parse(res.data);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: granolaKeys.all });
		},
	});
};
